'use client';

import { Root as LabelRoot } from '@radix-ui/react-label';
import { cva, type VariantProps } from 'class-variance-authority';
import { forwardRef, type ElementRef, type ComponentPropsWithoutRef } from 'react';

import { cn } from '@/lib/utils';
import { formFieldDisplayConfig } from './config';

const labelVariants = cva('text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70');

type LabelProps = ComponentPropsWithoutRef<typeof LabelRoot> &
  VariantProps<typeof labelVariants> & {
    required?: boolean;
  };

const Label = forwardRef<ElementRef<typeof LabelRoot>, LabelProps>(
  ({ className, children, required, ...props }, ref) => (
    <LabelRoot ref={ref} className={cn(labelVariants(), className)} {...props}>
      {children}
      {required && formFieldDisplayConfig.showRequiredAsterisk ? (
        <span aria-hidden="true" className="ml-0.5 text-red-500">
          *
        </span>
      ) : null}
    </LabelRoot>
  )
);

Label.displayName = LabelRoot.displayName;

export { Label };
